import css from './liftWinchPowerWidgetLegent.module.css'
import LowerBrakeIcon from '@/assets/icons/liftWinchPower/lowerBrake.svg?react'

const LiftWinchPowerWidgetLegent = () => {
  return (
    <div className="inline-flex-gap gap16">
      <div className="inline-flex-gap gap8 center">
        <div className={css.colorBlock} data-descriptor="active" />
        <p className="text-nm">Есть ток;</p>
      </div>
      <div className="inline-flex-gap gap8 center">
        <LowerBrakeIcon color="var(--success-border)" height={'16.8px'} />
        <p className="text-nm">Колодка сомкнута;</p>
      </div>
      <div className="inline-flex-gap gap8 center">
        <LowerBrakeIcon color="var(--error-border)" height={'16.8px'} />
        <p className="text-nm">Колодка разомкнута;</p>
      </div>
    </div>
  )
}

export default LiftWinchPowerWidgetLegent
